export default __webpack_public_path__ + "static/media/logo-ercoenergia.212e58e1.png";